import * as React from "react";

import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  columnName: string;
  confirmCb: () => void;
}

export const ConfirmDeleteNoteColumnDialog: React.FC<Props> = ({ isOpen, setIsOpen, columnName, confirmCb }) => (
  <Dialog open={isOpen} onOpenChange={setIsOpen}>
    <DialogContent className="max-w-sm">
      <DialogTitle>Delete column &ldquo;{columnName}&rdquo;?</DialogTitle>
      <DialogDescription>
        This permanently removes all notes in this column across every row. This cannot be undone.
      </DialogDescription>

      <div className="mt-3 flex justify-end gap-2">
        <Button variant="outline" size="sm" onClick={() => setIsOpen(false)}>
          Cancel
        </Button>
        <Button variant="destructive" size="sm" onClick={() => confirmCb()}>
          Delete
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
